import React from 'react';
import ReactDOM from 'react-dom/client';
import {
  createBrowserRouter,
  RouterProvider,
} from 'react-router-dom';
import { ThemeProvider } from '@mui/material';

import './index.css';
import theme from './Theme';
import reportWebVitals from './reportWebVitals';

import App from './App';
import Terms from './Terms';
import Privacy from './Privacy';

const router = createBrowserRouter([
  {
    path: '/pano/terms',
    element: <Terms appName="PANO" appLink="https://apps.apple.com/us/app/id1433880640" />,
  },
  {
    path: '/pano/privacy',
    element: <Privacy appName="PANO" appLink="https://apps.apple.com/us/app/id1433880640" />,
  },
  {
    path: '/conte/terms',
    element: <Terms appName="Conte" appLink="https://apps.apple.com/us/app/id1333505670" />,
  },
  {
    path: '/conte/privacy',
    element: <Privacy appName="Conte" appLink="https://apps.apple.com/us/app/id1333505670" />,
  },
  {
    path: '/product-photo/terms',
    element: <Terms appName="Product Photo" appLink="https://apps.apple.com/us/app/id1614491681" />,
  },
  {
    path: '/product-photo/privacy',
    element: <Privacy appName="Product Photo" appLink="https://apps.apple.com/us/app/id1614491681" />,
  },
  {
    path: '/*',
    element: <App />,
  },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <RouterProvider router={router} />
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
